
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import MapController from "./map_controller.js";
application.register("map", MapController);

import FiltersController from "./filters_controller.js";
application.register("filters", FiltersController);

import SelectController from "./select_controller.js";
application.register("select", SelectController);

import LineController from "./line_controller.js";
application.register("line", LineController);

import ShipController from "./ship_controller.js";
application.register("ship", ShipController);

import PersonResourceController from "./person-resource_controller.js";
application.register("person-resource", PersonResourceController);

import DocumentFiltersController from "./document-filters_controller.js";
application.register("document-filters", DocumentFiltersController);

import ToggleTranscriptController from "./toggle_transcript_controller"
application.register('toggle-transcript', ToggleTranscriptController)

import FamilyTreeController from "./family_tree_controller"
application.register('family-tree', FamilyTreeController)

import TreeController from "./tree_controller.js";
application.register("tree", TreeController);
import PdfViewerController from "./pdf_viewer_controller.js";
application.register("pdf-viewer", PdfViewerController);

import ArchiveToolsController from "./archive_tools_controller.js";
application.register("archive-tools", ArchiveToolsController);

import ChatScrollController from "./chat_scroll_controller.js";
application.register("chat-scroll", ChatScrollController);

import ChatFormController from "./chat_form_controller.js";
application.register("chat-form", ChatFormController);

import AutoSubmitController from "./auto_submit_controller.js";
application.register("auto-submit", AutoSubmitController);

import BackToTopController from "./back_to_top_controller.js";
application.register("back-to-top", BackToTopController);
